import { render, staticRenderFns } from "./FoodPyramid.vue?vue&type=template&id=2bc33a72"
import script from "./FoodPyramid.vue?vue&type=script&lang=js"
export * from "./FoodPyramid.vue?vue&type=script&lang=js"
import style0 from "./FoodPyramid.vue?vue&type=style&index=0&id=2bc33a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports